import React from 'react';

import { ResultOf } from '@graphql-typed-document-node/core';

import { Tabs } from '@repo/ui/Tabs';
import { TabDataCard } from '@repo/ui/Tabs';
import { DataCardGroup } from '@repo/ui/Tabs';

import CampaignsTable from '@/features/tcr/components/CampaignsTable';

import BRAND_SHOW_Q from '../gql/brandShow.gql';
import { useAccount } from '@/hooks/useAccount';
export type BrandViewPropsData = ResultOf<typeof BRAND_SHOW_Q>;

export interface BrandViewProps {
  data: BrandViewPropsData | undefined;
  error?: Error | undefined;
  loading: boolean;
}

const BrandView = ({ data, error, loading }: BrandViewProps) => {
  const cspBrand = data?.cspBrand;

  const account = useAccount();
  const accountId = account.id;

  const BrandOverviewData: DataCardGroup[] = [
    {
      groupTitle: 'Company details',
      columnCount: 3,
      groupData: [
        {
          label: 'Legal Company name',
          entry: cspBrand?.companyName,
        },
        {
          label: 'Brand name or DBA',
          entry: cspBrand?.displayName,
        },
        {
          label: 'Entity type',
          entry: cspBrand?.entityType,
        },

        {
          label: 'Country of registration',
          entry: cspBrand?.country,
        },

        {
          label: 'EIN',
          entry: cspBrand?.ein,
        },
        {
          label: 'EIN issuing country',
          entry: cspBrand?.einIssuingCountry,
        },

        {
          label: 'State',
          entry: cspBrand?.state,
        },
        {
          label: 'City',
          entry: cspBrand?.city,
        },
        {
          label: 'Street',
          entry: cspBrand?.street,
        },
        {
          label: 'Zip/Postal code',
          entry: cspBrand?.postalCode,
        },
        {
          label: 'Country',
          entry: cspBrand?.country,
        },
        {
          label: 'Website',
          entry: cspBrand?.website,
        },
        {
          label: 'Email address',
          entry: cspBrand?.email,
        },

        {
          label: 'Business vertical',
          entry: cspBrand?.vertical,
        },

        {
          label: 'Stock symbol',
          entry: cspBrand?.stockSymbol,
        },
        {
          label: 'Stock exchange',
          entry: cspBrand?.stockExchange,
        },
      ],
    },
  ];

  const ContactData: DataCardGroup[] = [
    {
      groupTitle: 'Contact',
      columnCount: 3,
      groupData: [
        {
          label: 'Phone number',
          entry: cspBrand?.phoneNumber,
        },
        {
          label: 'Email address',
          entry: cspBrand?.email,
        },
      ],
    },
  ];

  const BrandTabs = [
    {
      title: 'Overview',
      contents: (
        <>
          <TabDataCard
            title="Company details"
            icon="business"
            loading={loading}
            data={BrandOverviewData}
          />
          <TabDataCard
            title="Support contact details"
            loading={loading}
            icon="support_agent"
            data={ContactData}
          />
        </>
      ),
    },

    {
      title: 'Campaigns',
      contents: <CampaignsTable accountId={accountId} brandId={cspBrand?.tcr_brand_id} />,
    },
  ];

  return <Tabs tabs={BrandTabs} loading={loading} error={error} />;
};

export default BrandView;
